import { useId, type InputHTMLAttributes } from 'react';
import styles from './Radio.module.css';

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
}

export function Radio({ label, id, className, ...props }: RadioProps) {
  const generatedId = useId();
  const radioId = id || generatedId;

  return (
    <label htmlFor={radioId} className={[styles.container, className].filter(Boolean).join(' ')}>
      <input
        type="radio"
        id={radioId}
        className={styles.input}
        {...props}
      />
      <span className={styles.checkmark} />
      <span className={styles.label}>{label}</span>
    </label>
  );
}

Radio.displayName = 'Radio';
